import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Divider,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody
} from "@mui/material";
import {Form, Formik} from "formik"
// import axios from "axios";
import React, { useEffect, useState } from "react";
// import { rowDetailType } from "./MemberTable";
//import Waveform from "../../component/common/waveSurfer/WaveForm.js";
import api from "../../../../../API";
import { StringDecoder } from "string_decoder";
import { useSelector } from "react-redux";
import { getConTypeText } from "./MemberAssignmentTable";

// interface userDetailProps {
  
// }
interface AssignMentProps {
  con_type:string
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
  getScriptStatus: () => Promise<void>
}


const AssignMentDialog = (props: AssignMentProps) => {
  // console.log("props", props);
  const [con_type, setCon_type] = useState(props.con_type);
  const [script, setScript] = useState([]);
  const [member, setMember] = useState([]);

  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  const scriptList = async () => {
    api.get('/scriptList-assignment', {params: {email:email,con_type:con_type}})
    .then((res:any) => {console.log("스크립트 리스트 ", res.data.datas); setScript(res.data.datas); })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  const getAssignMentMember = async () => {
    var result = await api.get("/dialogScriptReadyMember",{params:{email:email}});
    console.log("할당 대상자", result.data);
    var datas = result.data.datas.map((data: any, idx: any) => {
      return {
        id: idx + 1,
        email: data.email,
        name: data.name,
        birth: data.birth,
        gender: data.gender,
        phone: data.phone,
        asg_type: data.asg_type,
        asg_info: data.asg_info,
        cnt: data.cnt,
        work_cnt: 0
      };
    });
    // table에 넣을 rows 데이터 state에 저장
    setMember(datas);
  };

  const goAssignMent = async (data:any) => {

    console.log('goAssignMent' , data)
    // return ;
    api.post('/assignMent',data)
    .then((res:any) => {console.log("할당완료", res.data.datas); alert("스크립트 할당 완료.\n 워커 : " + data.worker + " \n대화주제:" + con_type + "\n 할당 :" + data.work_cnt + "건"); scriptList(); })
      // alert("파일 업로드가 완료되었습니다.");
    .catch((error:any) => {console.error('에러',error.response);})
    // alert("파일 업로드 실패. " + error.response.data.error);
  }

  useEffect(() => {
    scriptList()
    getAssignMentMember()
  }, []);

  return (
    <Box >
    <Dialog maxWidth="lg" open={true} fullWidth={true}>
      <DialogTitle sx={{padding: "16px 24px 0px 24px"}}>
        <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>{getConTypeText(con_type)} - 작업할당</Box>
        <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      </DialogTitle>
      <DialogContent dividers>
        <Box sx={{display:"flex"}}>
          <Box sx={{padding:"20px 8px 8px 8px"}}>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>할당전 스크립트 목록 (<b style={{color:"#FFBB28"}}>{script.length}</b> 건)</Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"440px",fontSize:"12px"}}>
              <Table sx={{ minWidth: 400 }} size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",width:"30px", color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>IDX</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>관리 PK</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",width:"30px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>주제</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",width:"50px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>주제세부</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>요약</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>키워드</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당워커ID</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>녹음파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>자막파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>사진파일</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {script.length > 0 ? script.map((row:any, idx:number) => (
                    <React.Fragment key={idx+1}>
                      <TableRow
                        key={idx+1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                        <TableCell component="th" scope="row" align="center">{row.idx}</TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.mgm_con_pk}</Box></TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"10px"}}>{getConTypeText(row.con_type)}</Box></TableCell>
                        {/* <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.sub_subject}</Box></TableCell> */}
                        {/* <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.summary}</Box></TableCell>
                        <TableCell align="left"><Box sx={{fontSize:"10px"}}>{row.knowledge}</Box></TableCell> */}
                        {/* <TableCell align="left">{row.worker_id}</TableCell> */}
                        {/* <TableCell align="left">{sample.file_srt}</TableCell>
                        <TableCell align="left">{sample.file_photo}</TableCell> */}
                      </TableRow>
                    </React.Fragment>
                  )):""}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{padding:"20px 8px 8px 8px"}}>
            <Box sx={{marginLeft:"2px", marginRight:"20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>할당 대기자 목록</Box>
            <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
            <TableContainer sx={{maxHeight:"440px",fontSize:"12px"}}>
              <Table sx={{ minWidth: 400 }} size="small" aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>워커 정보</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>정보</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",width:"50px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당 건수</Box></TableCell>
                    {/* <TableCell align="center"><Box sx={{fontSize:"12px",width:"50px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>생년월일</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>성별</Box></TableCell>
                    <TableCell align="center"><Box sx={{fontSize:"12px",color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>연락처</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>할당워커ID</Box></TableCell> */}
                    {/* <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>녹음파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>자막파일</Box></TableCell>
                    <TableCell align="center"><Box sx={{color:"#fff", fontWeight:600, backgroundColor:"#95b1d1", padding:"1px 4px 1px 4px", borderRadius:"4px"}}>사진파일</Box></TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {member.length > 0 ? member.map((row:any, idx:number) => (
                    <React.Fragment key={idx+1}>
                      <TableRow
                        key={idx+1}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                      >
                            <TableCell component="th" scope="row" align="center">
                              <Box>{row.name}({row.email})</Box>
                              <Box>{row.gender}({row.phone})</Box>
                            </TableCell>
                            <TableCell component="th" scope="row" align="center">
                              <Box>{(row.asg_type === "first" || row.asg_type === "add" ) ? <b>{row.asg_info}</b> : <b>{row.asg_info+"("+row.cnt+")"}</b>}</Box>
                            </TableCell>
                            <TableCell align="left">

                            <Formik
                              initialValues={{email:email,con_type:con_type,worker:row.email, work_cnt:0,asg_type:row.asg_type}}
                              onSubmit={(values) => {
                                console.log(values);
                                goAssignMent(values);
                              }}
                            >
                              {({ values, handleChange, setFieldValue, submitCount }) => (
                                <Form>
                                
                                <Box sx={{fontSize:"10px", display:"flex", justifyContent:"center"}}>
                                  <TextField sx={{width:"80px"}} id="work_cnt" name="work_cnt" size="small" type="number"
                                    value={values.work_cnt} // Formik의 values에서 필드 값을 가져옵니다.
                                    onChange={(e) => {
                                      const inputValue = parseInt(e.target.value, 10);
                                      if ((row.asg_type === "first" || row.asg_type === "add" )) {
                                        if(inputValue > 75){
                                          if(inputValue > script.length){
                                            setFieldValue("work_cnt", script.length);
                                          }else{
                                            setFieldValue("work_cnt", 75);
                                          }
                                        }else if(inputValue <= 75){
                                          if(inputValue > script.length){
                                            setFieldValue("work_cnt", script.length);
                                          }else{
                                            setFieldValue("work_cnt", inputValue);
                                          }
                                        }
                                      }
                                      else if(row.asg_type === "ing"){
                                        // 진행중인 할당이 75에 맞도록 설정
                                        if(inputValue > (75-row.cnt)){  // 80 입력 > 70개 줄수있는데
                                          if(script.length < (75-row.cnt)){
                                            setFieldValue("work_cnt", script.length);
                                          }else{
                                            setFieldValue("work_cnt", (75-row.cnt));
                                          }
                                        }else if(inputValue <= (75-row.cnt)){
                                          if(inputValue > script.length){
                                            setFieldValue("work_cnt", script.length);
                                          }else{
                                            setFieldValue("work_cnt", inputValue);
                                          }
                                        }
                                      }
                                    }}
                                  />
                                  {submitCount ? <Button variant="contained" sx={{backgroundColor:"#03cf5d"}}>완료</Button>: <Button variant="contained" type="submit">할당</Button>}
                                  
                                </Box>
                                
                                </Form>
                              )}
                            </Formik>

                            </TableCell>
                        {/* <TableCell align="left">{row.worker_id}</TableCell> */}
                        {/* <TableCell align="left">{sample.file_srt}</TableCell>
                        <TableCell align="left">{sample.file_photo}</TableCell> */}
                      </TableRow>
                    </React.Fragment>
                  )):""}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" sx={{fontWeight:800, margin:"8px 16px"}}
          onClick={() => {
            props.setDialogOpen(false)
            props.getScriptStatus()
          }}
        >
          닫기
        </Button>
      </DialogActions>
    </Dialog>
    </Box>
  );
};

export default AssignMentDialog;
